module.exports = __webpack_public_path__ + "static/img/img-Background.e764a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-Background.png
// module id = lEOO
// module chunks = 1